import { computed, Directive, effect, inject, input } from '@angular/core';
import { TelemonitoringLinkDirective } from '@modules/telemonitoring/directives/telemonitoring-link.directive';
import { FlattenedSequence } from '@pixacare/dtos';

@Directive({
  selector: '[sequenceTelemonitoringLink]',
  hostDirectives: [TelemonitoringLinkDirective],
  host: {
    '[style.display]': 'isHidden() ? "none" : null',
  },
})
export class SequenceTelemonitoringLinkDirective {
  private readonly telemonitoringLinkDirective = inject(TelemonitoringLinkDirective);

  readonly sequenceTelemonitoringLink = input<FlattenedSequence | null>(null);

  readonly isHidden = computed(() => !this.sequenceTelemonitoringLink()?.sequenceInstance.telemonitoringId);

  constructor() {
    effect(() => {
      const sequence = this.sequenceTelemonitoringLink();
      if (!sequence?.sequenceInstance.telemonitoringId) {
        return;
      }

      this.telemonitoringLinkDirective.telemonitoringLink = sequence.sequenceInstance.telemonitoringId;
      this.telemonitoringLinkDirective.clientCode = sequence.clientCode;
    });
  }
}
